export const PDFdownloadButton = ({ href, children }) => (
  <div className=' max-w-[788px] flex gap-4 justify-left  '>
    <img src='/pdfIcon.png' className='h-12' />
    <a
      href={href}
      target='_blank'
      className='px-4 py-2 bg-light-blue text-white rounded  flex gap-4 items-center font-bold hover:bg-dark-blue transition-colors duration-200 text-xl border-2 border-dark-blue cursor-pointer shadow-lg'
      rel='noreferrer'
    >
      <span>{children || 'Download PDF'}</span>
      {/* <div className='bg-white rounded-full p-1 w-fit flex-0 aspect-square overflow-hidden '>
        <img
          src='/pdfIcon.png'
          alt='PDF Icon'
          className='inline-block h-8 bg-none'
        />
      </div> */}
    </a>
  </div>
);

export const PDFAnchor = ({ href, children }) => (
  <a
    href={href}
    target='_blank'
    rel='noopener noreferrer'
    style={{
      textDecoration: 'underline',
    }}
    className='text-blue-600 transition-colors duration-200 text-lg cursor-pointer hover:text-blue-700'
  >
    {children || 'Download PDF'}
  </a>
);

export const pdfFiles = {
  introduction: [
    {
      name: 'Module Companion Guide: Introduction',
      url: '/resource-library/mod1/Module-Companion-Guide-Introduction.pdf',
    },
  ],
  strategiesPart1: [
    {
      name: 'Program Strategies Part 1 and 2',
      url: '/resource-library/mod2/PROGRAM-PARENTING-STRATEGIES.pdf',
    },
    {
      name: 'Examples of Evening & Morning Routines',
      url: '/resource-library/mod2/Evening-&-Morning-Routines.pdf',
    },
    {
      name: 'Examples of Labeled Praise and Encouragement',
      url: '/resource-library/mod2/Examples-of-Labeled-Praise-and-Encouragement.pdf',
    },
    {
      name: 'How to Begin and End a Reward Program',
      url: '/resource-library/mod2/How-to-Begin-and-End-an-Effective-Award-Program.pdf',
    },
    {
      name: 'Common Mistakes Made with Reward Programs',
      url: '/resource-library/mod2/Common-mistakes-with-reward-programs.pdf',
    },
    {
      name: (
        <>
          Examples of <i>DO</i> Statements and Unclear Commands
        </>
      ),
      url: '/resource-library/mod2/Say-What-You-Mean-Mean-What-You-Say.pdf',
    },
    {
      name: 'The Meaning Behind Routines',
      url: '/resource-library/mod2/The-Meaning-Behind-Routines.pdf',
    },
  ],
  strategiesPart2: [
    {
      name: 'Examples of Household Rules',
      url: '/resource-library/mod2/Examples-of-Household-Rules.pdf',
    },
    {
      name: 'Examples of If/Then & When/Then Statements',
      url: '/resource-library/mod3/Example-of-If-then-and-When-then.pdf',
    },
    {
      name: 'Common Questions About Ignoring',
      url: '/resource-library/mod3/5-Common-Questions-About-Ignoring.pdf',
    },
    {
      name: '8 Keys to Effective Discipline',
      url: '/resource-library/mod3/8-Keys-to-Effective-Discipline.pdf',
    },
    {
      name: 'Steps to an Effective Time-Out',
      url: '/resource-library/mod3/Steps-to-Time-Out.pdf',
    },
    {
      name: 'Common Parent Questions About Time-Out',
      url: '/resource-library/mod3/Common-Parent-Questions-about-Time-Out.pdf',
    },
    {
      name: 'Take 5 Breathing Exercise',
      url: '/resource-library/mod3/Take-5-Breathing-Exercise.pdf',
    },
    {
      name: 'Mind Jar',
      url: '/resource-library/mod3/Mind-Jar-Handout.pdf',
    },
    {
      name: '“You” versus “I” Statements',
      url: '/resource-library/mod3/You-versus-I-statements.pdf',
    },
    {
      name: 'Steps to Problem Solving',
      url: '/resource-library/mod3/Steps-for-Problem-Solving.pdf',
    },
  ],
  hybridDelivery: [
    {
      name: 'Session #1 (Introduction) ezParent Fidelity Checklist',
      url: '/resource-library/mod4/Fidelity-Checklist-Group-Session-1.pdf',
    },
    {
      name: 'Session #2 (Mod 1 & 2) ezParent Fidelity Checklist',
      url: '/resource-library/mod4/Fidelity-Checklist-Group-Session-2.pdf',
    },
    {
      name: 'Session #3 (Mod 3 & 4) ezParent Fidelity Checklist',
      url: '/resource-library/mod4/Fidelity-Checklist-Group-Session-3.pdf',
    },
    {
      name: 'Session #4 (Mod 5 & 6) ezParent Fidelity Checklist',
      url: '/resource-library/mod4/Fidelity-Checklist-Group-Session-4.pdf',
    },
    {
      name: '1-on-1 Coaching with ezParent',
      url: '/resource-library/mod4/1-on-1-Coaching.pdf',
    },
  ],
};
